/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for QrCodeCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { PaymentRequestDto, RequestOptions, PaymentResponseDto } from "../models";

@Injectable({ providedIn: "root" })
export class QrCodeCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    qrPayment(paymentRequestDto: PaymentRequestDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<PaymentResponseDto>;
    qrPayment(paymentRequestDto: PaymentRequestDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PaymentResponseDto>>;
    qrPayment(paymentRequestDto: PaymentRequestDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PaymentResponseDto>>;
    qrPayment(paymentRequestDto: PaymentRequestDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/qrcode/payments`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: paymentRequestDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
